var exports = {
  "pq": "UserIdentityRow.module__info___ZV9mal",
  "UU": "UserIdentityRow.module__name___ZV9mal",
  "Tc": "UserIdentityRow.module__tag___ZV9mal",
};

module.exports = exports;
